import { useContext, useEffect, useRef, useState } from "react";
import { notification } from "antd";
import { UserContext } from "@/shared/contexts/user.context";
import { useNavigate, useParams } from "react-router-dom";
import { ASSESSMENT_ROUTE, CANDIDATE_ROUTE, SELF_REGISTER_ROUTE } from "@/routing/AppRouter/routes.constants";
import { AssessmentHttpService } from "@/modules/assessments/services/assessment-http.service";
import { getFriendlyErrorMessage } from "@/shared/services/http";

export function AssessmentSelfRegister() {
  const navigate = useNavigate();
  const { user, isLoading } = useContext(UserContext);
  const { assessmentId } = useParams();
  const isAuthenticated: boolean = Boolean(user && user.userId);
  const [inviteCode, setInviteCode] = useState<string | null>(null);
  const inviteRequested = useRef(false);
  const createInvite = async () => {
    try {
      const data = await AssessmentHttpService.createInvite(Number(assessmentId));

      return data.data.code && setInviteCode(data.data.code);
    } catch (error) {
      // This scene renders nothing until it has an invite code, so a silent failure
      // strands the candidate on an empty page at their entry point into the
      // assessment. Releasing the guard lets a later auth change retry the request.
      inviteRequested.current = false;
      notification.error({
        message: getFriendlyErrorMessage(error) ?? "We couldn't start your assessment. Please refresh and try again.",
      });
    }
  };

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate(`/${CANDIDATE_ROUTE}/${ASSESSMENT_ROUTE}/${assessmentId}/${SELF_REGISTER_ROUTE}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  useEffect(() => {
    if (isAuthenticated && !inviteRequested.current) {
      inviteRequested.current = true;
      createInvite();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  useEffect(() => {
    if (inviteCode) {
      navigate(`/${CANDIDATE_ROUTE}/invites/${inviteCode}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inviteCode]);

  return null;
}
